import { render } from "./AboutView.vue?vue&type=template&id=ff5759a6&bindings={}"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"

import "./AboutView.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script